import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <section {...{
      "className": "section-lead"
    }}><p parentName="section">{`Sets the locale. Must be one of the languages supported for this `}<a parentName="p" {...{
          "href": "/api/../api/projects/project"
        }}>{`Project`}</a>{`.`}</p>
      <ul parentName="section">
        <li parentName="ul"><inlineCode parentName="li">{`action`}</inlineCode>{` - String - `}<inlineCode parentName="li">{`"setLocale"`}</inlineCode></li>
        <li parentName="ul"><inlineCode parentName="li">{`locale`}</inlineCode>{` - String conforming to `}<a parentName="li" {...{
            "href": "https://en.wikipedia.org/wiki/IETF_language_tag"
          }}>{`IETF language tag`}</a>{` - Optional`}</li>
      </ul>
    </section>
    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      